'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'hat-wizard';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f6e8';
var svgPathData = ['M65.5 416l381 0-89.3-200.9c-3.4-7.7-5.2-16.1-5.2-24.5 0-6 .9-11.9 2.6-17.6L392.1 49.7c2.1-6.8-5-12.7-11.3-9.4l-137.5 71c-35.6 18.4-63.8 48.3-80.1 84.9L65.5 416zM168 320c0-4.4 3.6-8 8-8l40 0 0-40c0-4.4 3.6-8 8-8s8 3.6 8 8l0 40 40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0 0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-40-40 0c-4.4 0-8-3.6-8-8zm64-144c0-4.4 3.6-8 8-8l24 0 0-24c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0 0 24c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-24-24 0c-4.4 0-8-3.6-8-8zM368.1 28.8l5.3-2.8c15.8-8.2 33.3 3 34.9 18.8l7.4-21.2c1.9-5.3-.7-11.2-5.9-13.5-3.1-1.4-6.7-1.2-9.6 .5L368.1 28.8z', 'M446.5 416l-381 0 97.7-219.8c16.3-36.6 44.5-66.5 80.1-84.9l137.5-71c6.3-3.2 13.4 2.7 11.3 9.4L354.6 173c-1.7 5.7-2.6 11.6-2.6 17.6 0 8.4 1.8 16.8 5.2 24.5L446.5 416zM148.6 189.7L48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48l416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L371.8 208.6c-2.5-5.7-3.8-11.8-3.8-18 0-4.4 .6-8.7 1.9-12.9L407.4 54.4c6.2-20.3-15.1-38-34-28.3L236 97c-38.8 20-69.6 52.7-87.4 92.6zM464 432c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 496c-17.7 0-32-14.3-32-32s14.3-32 32-32l416 0zM280 144c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24-24 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 24c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24 24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-24zM232 272c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 40-40 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l40 0 0 40c0 4.4 3.6 8 8 8s8-3.6 8-8l0-40 40 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-40 0 0-40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHatWizard = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;